import { render, staticRenderFns } from "./SingleProfile.vue?vue&type=template&id=c9b03708&scoped=true"
import script from "./SingleProfile.vue?vue&type=script&lang=js"
export * from "./SingleProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b03708",
  null
  
)

export default component.exports